import { withForm } from '@/core/form/withForm';
import BaseMultiSelect from '@/components/atoms/MultiSelect';

export const MultiSelect = withForm(BaseMultiSelect);
